import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseUserswallet() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getWalletList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Wallets?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getWalletByMobile = (Mobile, callback) => {
    MyAxios.get(`Admin_Wallets/${Mobile}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddWallet = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Wallets/Add`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("درخواست افزودن به کیف پول ارسال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const SubtractWallet = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Wallets/Subtract`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("درخواست کسر از کیف پول ارسال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const getOffersList = (callback) => {
    MyAxios.get(`Admin_ManageWallets/WalletOffers`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    getWalletList,
    getWalletByMobile,
    AddWallet,
    SubtractWallet,
    getOffersList,
  };
}
